var state = {
  myModalVisibleCount: 0
}

const getters = {
}

const actions = {
}

var mutations = {
    setField (state, { field, value }) {
        state[field] = value
    },
    incrementMyModalVisibleCount(state) {
        state.myModalVisibleCount++
    },
    decrementMyModalVisibleCount(state) {
        state.myModalVisibleCount--
    }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
